// ICAO Doc 9303 TD3 — Passport MRZ (2 lines × 44 chars = 88 chars total)
//
// Line 1 [0–43]:  P<CRI<SURNAMES<<GIVEN_NAMES<<<<<<<<<<<<<<<
// Line 2 [44–87]: <passport_number><chk><nationality><dob><chk><sex><expiry><chk><optional><chk><overall_chk>

export const MRZ_PASSPORT_REGEX = /^P[A-Z0-9<]{87}$/

function computeCheckDigit(str) {
  const weights = [7, 3, 1]
  let total = 0
  for (let i = 0; i < str.length; i++) {
    const c = str[i]
    const val = c === '<' ? 0 : c >= 'A' ? c.charCodeAt(0) - 55 : parseInt(c)
    total += val * weights[i % 3]
  }
  return String(total % 10)
}

export default function MRZPassportReader(mrz) {
  const line1 = mrz.slice(0, 44)   // "P<CRISURNAME<<GIVEN<<<<<<<<<<<<<<<<<<<<<<<<<"
  const line2 = mrz.slice(44, 88)  // "A12345678<9CRI8501014M2712316<<<<<<<<<<<<<6"

  // Line 2: passport number [0:9], check digit [9]
  const passportNumRaw = line2.slice(0, 9)
  const checkDigit = line2[9]
  const identification = passportNumRaw.replace(/</g, '')

  if (computeCheckDigit(passportNumRaw) !== checkDigit) {
    console.warn('[MRZPassportReader] Check digit mismatch for passport number:', identification)
  }

  // Line 1: names start at position 5 (after P + subtype + country)
  const namesField = line1.slice(5)
  const [surnames, givenNames = ''] = namesField.split('<<')
  const [last_name = '', last_name_two = ''] = surnames.split('<')
  const first_name = givenNames.replace(/</g, ' ').trim()

  return { identification, first_name, last_name, last_name_two }
}
